import React, {useEffect, useRef, useState} from 'react';
import {Box, Button, HStack, Spinner, Text} from '@chakra-ui/react';
import {useParams} from "react-router-dom";
import axios from "axios";

const News = ({setHasNewsData}) => {
    const newsRef = useRef();
    const [newsData, setNewsData] = useState(undefined)
    const {slug} = useParams();
    const [startIndex, setStartIndex] = useState(0)

    useEffect(() => {
        const abortController = new AbortController();
        const fetchNews = async () => {
            const response = await axios.get(`/wp-admin/admin-ajax.php?action=get_news&news_start=${startIndex}&team_slug=${slug}`, {signal: abortController.signal}).then(resp => {
                return resp.data;
            });
            setNewsData(response)
            // if (startIndex) {
            //     scrollToNews()
            // }
        }
        fetchNews()
        return () => {
            abortController.abort();
        }
    }, [slug, startIndex])


    const scrollToNews = () => {
        if (newsRef && newsRef.current) {
            // eslint-disable-next-line no-unused-expressions
            newsRef.current?.scrollIntoView({behavior: 'smooth'});
        }
    }


    if (newsData?.length < 1) {
        setHasNewsData(false)
        return <></>
    }
    setHasNewsData(true)
    return (
        <>
            <Box pl={{md: '21px', base: '0'}}>
                <Text mb={'41px'} fontSize={'18px'} lineHeight={'18px'} ref={newsRef}>
                    News
                </Text>
                {!newsData ?
                    (
                        <Box my={20} width="100%" textAlign="center">
                            <Spinner color='blue.600' size='xl'/>
                        </Box>
                    )
                    :
                    (<>
                        {newsData?.map((data, key) => (
                            <NewsItem key={key} data={data}/>
                        ))}
                        <HStack spacing='24px' paddingTop={{base: 0, md: 30}}>
                            {startIndex > 0 &&
                                <Button
                                    size={'sm'}
                                    py={'18px'}
                                    minW={'100px'}
                                    textColor={'black'}
                                    fontWeight={'semibold'}
                                    fontSize={'xs'}
                                    variant={'brand'}
                                    borderRadius={'full'}
                                    colorScheme={'brand'}
                                    borderColor={'rgba(11, 46, 251, 0.5)'}
                                    onClick={() => {
                                        setStartIndex(startIndex - 5)
                                        scrollToNews()
                                    }}
                                >
                                    Previous
                                </Button>
                            }
                            {newsData.length > 9 &&
                                <Button
                                    size={'sm'}
                                    py={'18px'}
                                    minW={'100px'}
                                    textColor={'black'}
                                    fontWeight={'semibold'}
                                    fontSize={'xs'}
                                    variant={'brand'}
                                    borderRadius={'full'}
                                    colorScheme={'brand'}
                                    borderColor={'rgba(11, 46, 251, 0.5)'}
                                    onClick={() => {
                                        // scrollToTop()
                                        setStartIndex(parseInt(startIndex.toString()) + 5)
                                        scrollToNews()
                                    }}
                                >
                                    Next
                                </Button>
                            }
                        </HStack>
                    </>)
                }
            </Box>
        </>
    );
};

export default News;

const NewsItem = ({data}) => {
    return (
        <a href={data?.link_url} target="_blank" rel="noopener noreferrer">
            <Box mb={'50px'} height={'80.28px'}>
                <Text mb={'5px'} 
                    color={'brand.700'} 
                    fontSize={'16px'} 
                    lineHeight={'32px'} 
                    overflow={'hidden'}
                    textOverflow={'ellipsis'}
                    whiteSpace={'nowrap'}
                >
                    {data?.news_source}
                </Text>
                <Text fontSize={'18px'} lineHeight={'21.6px'} noOfLines={'2'}>
                    {data?.post_title}
                </Text>
            </Box>
        </a>
    );
};
